export const authRole = {
  admin: ['admin', 'user'],
  user: ['user'],
};

export const RoutePermittedRole = {
  admin: 'admin',
  user: 'user',
};
export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'admin',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const initialUrl = '/clients/upload-data-to-client'; // this url will open after login
